import { motion } from 'motion/react'
import styled from 'styled-components';
import { Grid, Box } from '@mui/material';
import { Item, ItemIds } from '../../content/menu-items';
import { useEffect, useState } from 'react';


interface StyledItemProps {
    selected: boolean,
    index: number,
}

interface ItemSelectorProps {
    items: Item[],
    cart: Item[],
    handleSelectItem: Function,
}

const StyledItem = styled(motion.div)<StyledItemProps>`
    background-color:  ${(props)=>getBackgroundColor(props.index, props.selected)};
    padding: 15px; 
    margin: auto;
    margin-bottom: 30px; 
    width: 80vw; 
    max-width: 1000px; 
    height: 180px; 
    border: ${(props)=>props.selected? '1px solid red': '1px solid rgba(0,0,0,1)'};
    border-radius: 12px;
    transition: background-color .3s ease-in-out, border-color .5s ease-in-out;
    justify-content: center;
    filter: drop-shadow(0px 0px 5px black);
    position: relative;
    z-index: 1;
    backface-visibility: hidden;
    display: flex;
`

const getBackgroundColor = (index: number, selected: boolean) => {
    if(selected){
        return ('rgba( 80, 0, 0, 1)')
    }
    if(index % 2 === 1){
        return('rgba( 40, 40, 40, 1)')
    }
    else{
        return('rgba( 20, 20, 20, 1)')
    }
}

export const ItemSelector: React.FC<ItemSelectorProps> = ( {items, cart, handleSelectItem }: ItemSelectorProps) => {
    const [numEntreesInCart, setNumEntreesInCart] = useState(0)

    useEffect(()=>{
        const numEntreesPresent = cart.reduce((total, currentItem) => currentItem.id >= ItemIds.Tritip && currentItem.id <= ItemIds.StuffedJalapenos? total + 1 :0, 0)
        setNumEntreesInCart(numEntreesPresent)
    },[cart])

    return(
        <Box justifyContent='center' alignItems='center' margin='auto'  mb='15vh' paddingX='auto'>
        {items.map((item, index)=> 
            <StyledItem
                aria-label={cart.includes(item)? `Remove ${item.title} from cart`:`Add ${item.title} to cart`}
                key={item.id}
                id={`${item.id}`}
                //onClick={()=> {handleSelectItem(item)}}
                onTap={()=> {handleSelectItem(item)}}
                whileHover={{ scale: 1.08, filter:'drop-shadow(0px 0px 10px orange)',  zIndex: 10}}          
                selected={cart.includes(item)}
                index={index}
                tabIndex={0}
            >
                <motion.img
                    loading="lazy"
                    width="40%"
                    src={item.image}
                    alt={`A picture of ${item.title}`}
                    style={{marginRight:'10px', objectFit: 'cover', marginLeft:'auto', maxWidth:'320px', maxHeight:'180px'}}
                />
                <Grid container flexDirection='column' justifyContent='center'>
                    <Grid item flexDirection='row'>
                        <motion.div style={{display:'flex', color: 'white', fontSize: '22px', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                            {item.title}
                        </motion.div>
                    </Grid>
                    {numEntreesInCart >= 1 &&
                        <Grid item flexDirection='row'>
                            <motion.div style={{display:'flex', color: 'white', fontSize: '18px', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                Additional cost per person: ${item.pricePerPerson}
                            </motion.div>
                        </Grid>
                    }
                </Grid>
            </StyledItem>
        )}
        </Box>
    )
}

